export default __webpack_public_path__ + "static/media/img-1-1000x600.3869811c.jpg";